import {actionTypes, DeploymentType} from "../../types";

export const getAction = (model: string, type: DeploymentType) =>{
  return `${actionTypes[type]} (${model})`;
}
export async function createAuditLog(singularName: string, model: string, entry: any, type: DeploymentType) {
  const ctx = strapi.requestContext.get();
  const user = ctx?.state?.user;
  const auditLog = {
    action: getAction(model, type),
    payload: {
      uuid: singularName,
      model,
      entry
    },
    user: user.id,
    date: new Date()
  }

  await strapi.db?.query('admin::audit-log').create({data: auditLog});
}
